import ReferralInviteSend from './send'
import ReferralInviteThankYou from './thank-you'

export { ReferralInviteSend, ReferralInviteThankYou }
